import { useContext, useEffect, useRef } from "react";
import { Container, Grid, useMediaQuery, useTheme } from "@mui/material";
import DayView from "./DayView";
import ToolPanel from "./ToolPanel";
import { PlannerContext } from "../../context/planner/PlannerContext";

const DayPlanner = () => {
  const {
    selectedBlockId,
    setSelectedBlockId,
    setSelectedTool,
    selectedTool,
    setActiveTime,
    closeToolPanel,
  } = useContext(PlannerContext);
  const dayViewRef = useRef(null);
  const toolPanelRef = useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Only handle clicks if a block is selected or we're in edit/insert mode
      if (
        !selectedBlockId &&
        selectedTool !== "editBlock" &&
        selectedTool !== "insertBlock"
      ) {
        return;
      }

      const clickedInsideToolPanel =
        toolPanelRef.current && toolPanelRef.current.contains(event.target);

      // Never deselect if clicking inside the tool panel
      if (clickedInsideToolPanel) {
        return;
      }

      // Check if clicked on a block element
      const clickedBlock = event.target.closest(".block");

      // Check if clicked on a time marker add button or WIP box
      const clickedTimeMarkerButton = event.target.closest(
        ".time-marker_add-button-icon",
      );
      const clickedWipBox = event.target.closest(".wip-box");

      // Check if clicked on MUI Popover/Menu/Select elements (rendered in portals)
      const clickedMuiPopover = event.target.closest(".MuiPopover-root");
      const clickedMuiMenu = event.target.closest(".MuiMenu-root");
      const clickedMuiModal = event.target.closest(".MuiModal-root");
      const clickedMuiPopper = event.target.closest(".MuiPopper-root");

      // If clicked on a block, time marker button, or MUI portal element, don't deselect
      if (
        clickedBlock ||
        clickedTimeMarkerButton ||
        clickedWipBox ||
        clickedMuiPopover ||
        clickedMuiMenu ||
        clickedMuiModal ||
        clickedMuiPopper
      ) {
        return;
      }

      // Otherwise, deselect and return to day config
      setSelectedBlockId(null);
      setActiveTime(null);
      setSelectedTool("dayConfig");
      if (isMobile) {
        closeToolPanel();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    selectedBlockId,
    selectedTool,
    setSelectedBlockId,
    setSelectedTool,
    setActiveTime,
    isMobile,
    closeToolPanel,
  ]);

  return (
    <Container className="day-planner">
      <Grid container spacing={2}>
        <Grid item xs={12} md={7} ref={dayViewRef}>
          <DayView />
        </Grid>
        {/* On mobile, tool panel is shown as a dialog instead of in the grid */}
        {!isMobile && (
          <Grid item xs={12} md={5} ref={toolPanelRef}>
            <ToolPanel />
          </Grid>
        )}
        {/* Render ToolPanel for mobile (it handles its own dialog display) */}
        {isMobile && <ToolPanel />}
      </Grid>
    </Container>
  );
};

export default DayPlanner;
